import { style } from 'typestyle';
import { primaryTextColor, faintBorderColor, TEAL_PRIMARY } from 'src/common-ui/theme';

const agentFreeformContainer = style({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  minHeight: 0,
  overflow: 'hidden',
});

const messagesContainer = style({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  minHeight: 0,
});

const inputContainer = style({
  $debugName: 'agent-freeform-input-container',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '20px',
  borderTop: '1px solid ' + faintBorderColor,
  flexShrink: 0,
  backgroundColor: 'white',
});

const inputField = style({
  $debugName: 'agent-freeform-input',
  flex: 1,
  padding: '12px 16px',
  border: '1px solid #D1D5DB',
  borderRadius: '24px',
  fontSize: '0.9rem',
  outline: 'none',
  fontFamily: '"Open Sans", sans-serif',
  $nest: {
    '&:focus': {
      borderColor: TEAL_PRIMARY,
    },
    '&::placeholder': {
      color: '#9CA3AF',
    },
  },
});

const sendButton = style({
  $debugName: 'agent-freeform-send-button',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: TEAL_PRIMARY,
  color: 'white',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'opacity 0.2s',
  rotate: '90deg',
  $nest: {
    '&:hover:not(:disabled)': {
      opacity: 0.8,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
});

export default {
  agentFreeformContainer,
  messagesContainer,
  inputContainer,
  inputField,
  sendButton,
};
